
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(238|318|367|803)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
